import React from 'react';
import styled from 'styled-components';

const conditionalColor = '#8b4513';
const exceptionColor = '#ff8c00';

type TagType = 'conditional' | 'exception';

type TagColor = typeof conditionalColor | typeof exceptionColor;

const CloseButton = styled.button<{ color: TagColor }>`
  background: none;
  border: none;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0;
  color: ${({ color }) => color};
  font-size: 1rem;
`;

const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4L12 12M12 4L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

interface TagCloseButtonProps {
  onClick?: () => void;
  type: TagType;
}

const TagCloseButton = ({ onClick, type }: TagCloseButtonProps) => {
  return (
    <CloseButton
      aria-label="remove conditional"
      onClick={onClick}
      color={type === 'conditional' ? conditionalColor : exceptionColor}
    >
      <CloseIcon />
    </CloseButton>
  );
};

export default TagCloseButton;
